import { render, staticRenderFns } from "./document.vue.erb?vue&type=template&id=36a90daa"
import script from "./document.vue.erb?vue&type=script&lang=js"
export * from "./document.vue.erb?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports